import React from "react";
import { MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useContent } from "../ContentContext";

export default function Areas() {
  const { company } = useContent();
  return (
    <section id="areas" data-testid="areas-section" className="py-24 md:py-32" style={{ background: "var(--limestone)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-14 items-center">
        <div>
          <Eyebrow>Service Areas</Eyebrow>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-5xl leading-[0.95]"
              style={{ color: "var(--pine)" }}>
            Proudly serving <span className="font-serif-a italic normal-case font-medium" style={{ color: "var(--brass)" }}>North Alabama</span>
          </h2>
          <p className="mt-5 max-w-md leading-relaxed" style={{ color: "#4a4a4a" }}>
            Based in Huntsville and serving the surrounding communities across North Alabama and nearby Tennessee.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            {(company.areas || []).map((a) => (
              <span key={a} data-testid={`area-${a}`}
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium border"
                    style={{ background: "var(--bone)", borderColor: "rgba(0,0,0,0.08)", color: "var(--pine)" }}>
                <MapPin size={14} style={{ color: "var(--brass)" }} /> {a}
              </span>
            ))}
          </div>
        </div>
        <Reveal>
          <div className="rounded-2xl overflow-hidden border shadow-sm" style={{ borderColor: "rgba(0,0,0,0.08)" }}>
            <iframe title="Service area map — Huntsville, Alabama" data-testid="areas-map"
              src="https://www.google.com/maps?q=Huntsville,Alabama&output=embed"
              className="w-full h-[380px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
